'use strict'

export const cardPropertyMixin = {
  computed: {
    show: function () {
      return !this.tabProp._show || (!!this.object && this.tabProp._show(this.object))
    }
  },
  watch: {
    show: {
      handler: function (show) {
        if (this.tabProp) {
          if (!show) {
            this.$set(this.tabProp, '_shown', false)
          } else if (this.tabProp._shown != null) {
            this.$set(this.tabProp, '_shown', true)
          }
        }
      },
      immediate: true
    }
  }
}
